import { observer } from 'mobx-react-lite';
import { colors } from '../../../../colorVars';
import { useWebsocketStore } from '../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../utils/math/ApplyRounding';
import { Body4 } from '../../text/Text';
import style from './BidAskBox.module.css';

type Props = {
  symbol: string;
  dataSource: string;
  margin?: string;
};

export const BidAskBox = observer(({ symbol, dataSource, margin }: Props) => {
  const { priceDataStore } = useWebsocketStore();
  const hash = `${symbol}-${dataSource}`;
  const { bid, ask } = priceDataStore.lastQuote[hash] ?? { bid: 0, ask: 0 };
  return (
    <div className={style.container} style={{margin}}>
      <Body4 color={colors.lightGrey}>{`B:${ApplyRounding(
        bid,
        2
      )} A:${ApplyRounding(ask, 2)}`}</Body4>
    </div>
  );
});
